import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    width: ({ width }: propTypes) => width,
    marginTop: ({ mt }: propTypes) => mt,
    marginBottom: ({ mb }: propTypes) => mb,
    marginLeft: ({ ml }: propTypes) => ml,
    marginRight: ({ mr }: propTypes) => mr,

    height: ({ height }: propTypes) => height || 32,
    padding: '9px 0',

    fontSize: ({ fontSize }: propTypes) => fontSize || 12,
    fontWeight: 400,
    lineHeight: 0,

    borderRadius: 0,
    boxShadow: 'none',

    color: 'rgba(255,255,255, 0.4)',
    background: theme.palette.secondary.dark,
    '&:hover': {
      background: 'rgba(216,216,216, 0.15)',
      boxShadow: 'none',
    },
    '&.MuiButton-contained.Mui-disabled': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.secondary.main,
      opacity: 0.6,
    },
  },
  text: {
    textTransform: 'uppercase',
  },
}))

type propTypes = {
  text: string
  width: number | string
  mt?: number | string
  mb?: number | string
  ml?: number | string
  mr?: number | string
  type?: string
  href?: string
  disabled?: boolean
  onClick?: () => void
  height?: number | string
  fontSize?: number
}

export const GrayButton: React.FC<propTypes> = ({
  text,
  width,
  mt,
  mb,
  ml,
  mr,
  type,
  href,
  disabled,
  onClick,
  height,
  fontSize,
}) => {
  const classes = useStyles({ text, width, mt, mb, ml, mr, type, href, height, fontSize })
  const history = useHistory()

  const goTo = useCallback(() => {
    history.push(`${href}`)
  }, [history, href])

  return (
    <Button
      disabled={disabled}
      variant="contained"
      type="submit"
      className={classes.button}
      onClick={href ? goTo : onClick}
    >
      <span className={classes.text}>{text}</span>
    </Button>
  )
}
